import type { PropType } from 'vue';
import type { TIconProps } from './TIcon.types';
import { Icon } from '@iconify/vue';
import { get, merge } from 'es-toolkit/compat';
import { computed, defineComponent } from 'vue';
import { useTheme } from '../../composables/theme';

const defaultProps = {
  color: '#000',
  size: 'medium',
  variant: 'outline',
};

export const TIcon = defineComponent({
  name: 'TIcon',
  props: {
    icon: {
      type: String as PropType<TIconProps['icon']>,
      required: true,
    },
    color: String as PropType<TIconProps['color']>,
    size: String as PropType<TIconProps['size']>,
    variant: String as PropType<TIconProps['variant']>,
  },
  setup(_props, { attrs }) {
    const props = computed(() => merge({}, defaultProps, _props, attrs));

    const theme = useTheme();
    const color = computed(() => (get(theme.value.colors, props.value.color) as string)
      || props.value.color);
    const icon = computed(() => `${theme.value.iconSet}:${props.value.icon}${
      props.value.variant === 'solid' ? '-solid' : ''
    }`);

    const sizeMapping = {
      miniature: '6px',
      'extra-small': '10px',
      small: '16px',
      medium: '19px',
      large: '24px',
      'extra-large': '28px',
      huge: '44px',
    };
    const size = computed(() => sizeMapping[props.value.size]);

    return () => (
      <Icon
        icon={icon.value}
        color={color.value}
        height={size.value}
        width={size.value}
        {...attrs}
      />
    );
  },
});
